import React, { useEffect, useState } from "react";
import { ImageLink } from "../utils/constant";
import { FileText, UploadCloud } from "lucide-react";
import "./styles/ImageUpload.css";

const ImageUploadDragAndDrop = ({
  id,
  label,
  value,
  onChange,
  error,
  touched,
  accept = "image/*",
}) => {
  const [preview, setPreview] = useState("");
  const [fileType, setFileType] = useState("");
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      setPreview("");
      setFileType("");
      return;
    }

    if (value instanceof File) {
      const objectUrl = URL.createObjectURL(value);

      setPreview(objectUrl);
      setFileType(value.type);

      return () => URL.revokeObjectURL(objectUrl);
    }

    if (typeof value === "string") {
      const fileUrl = ImageLink(value);
      setPreview(fileUrl);

      const extension = value.split(".").pop()?.toLowerCase();

      if (extension === "pdf") {
        setFileType("application/pdf");
      } else {
        setFileType("image");
      }
    } else {
      setPreview("");
      setFileType("");
    }
  }, [value]);

  const handleFile = (file) => {
    if (file) {
      onChange(file);
    }
  };

  return (
    <div className="image-upload-wrapper">
      <label className="col-form-label">{label}</label>

      <div
        className={`upload-box ${isDragging ? "active" : ""
          } ${preview ? "has-preview" : ""}`}
        onDragOver={(e) => {
          e.preventDefault();
          setIsDragging(true);
        }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setIsDragging(false);

          const file = e.dataTransfer.files[0];
          handleFile(file);
        }}
      >
        <input
          id={id}
          name={id}
          type="file"
          accept={accept}
          className="file-input"
          onChange={(e) => handleFile(e.target.files[0])}
        />

        {preview ? (
          <div className="preview-inside-box">
            {fileType === "application/pdf" ? (
              <a
                href={preview}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                className="d-flex flex-column justify-content-center align-items-center text-decoration-none"
                style={{ height: "250px", zIndex: 10, position: "relative" }}
              >
                <FileText size={80} color="#a55353ff" />
                <span className="mt-2">Open PDF</span>
              </a>
            ) : (
              <img src={preview} alt="preview" className="inside-preview" />
            )}
          </div>
        ) : (
          <div className="upload-content">
            <div className="icon-wrapper">
              <UploadCloud size={36} strokeWidth={1.8} color="#116dff" />
            </div>

            <h6>
              Drag & Drop or <span>Browse</span>
            </h6>
          </div>
        )}
      </div>

      {error && touched && <small className="text-danger">{error}</small>}
    </div>
  );
};

export default ImageUploadDragAndDrop;